import Vue from 'vue';
import ColorizeImageSlider from '../../qaamgo/modules/sat/components/ColorizeImageSlider.vue';

// Import the library
import 'img-comparison-slider';

const firstImagePC = document.querySelector('.ai-upscale-image-wrapper').dataset.firstImagePc;
const secondImagePC = document.querySelector('.ai-upscale-image-wrapper').dataset.secondImagePc;

const firstImageAK = document.querySelector('.ai-upscale-image-wrapper').dataset.firstImageAk;
const secondImageAK = document.querySelector('.ai-upscale-image-wrapper').dataset.secondImageAk;

new Vue({
    el: '#aiUpscaleImageSliderPeacock',
    name: 'AiUpscaleImageSliderPeacock',
    components: {
        ColorizeImageSlider,
    },
    render(h) {
        return h(ColorizeImageSlider, {
            props: {
                firstImage: firstImagePC,
                secondImage: secondImagePC,
            },
        });
    },
});

new Vue({
    el: '#aiUpscaleImageSliderAkropolis',
    name: 'AiUpscaleImageSliderAkropolis',
    components: {
        ColorizeImageSlider,
    },
    render(h) {
        return h(ColorizeImageSlider, {
            props: {
                firstImage: firstImageAK,
                secondImage: secondImageAK,
            },
        });
    },
});
